import * as yup from 'yup';
import { RegistrationStatus, RegistryTypes } from './Data.conf';
import dayjs from 'dayjs';
import { API as yachts } from '../api';
import { API as provenanceList } from '../../provenenceLists/api';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);

export const FilterConf = {
  schema: yup.object({
    registry_type: yup.object().nullable(),
    registration_status: yup.array().nullable(),
    start_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    end_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test(
        'end-after-start',
        "End date can't be before Start date",
        function (value) {
          const { start_date } = this.parent;

          if (!value || !start_date) return true;
          return dayjs(value).isSameOrAfter(dayjs(start_date));
        }
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    id_yacht: yup.array().nullable(),
    provenance: yup.array().nullable(),
  }),
  initialState: {
    value: {
      registry_type: null,
      registration_status: [],
      start_date: dayjs.utc().format('YYYY-MM-DD').toString(),
      end_date: dayjs.utc().endOf('year').format('YYYY-MM-DD').toString(),
      id_yacht: null,
      provenance: null,
    },
  },
  fields: [
    {
      id: 'registry_type',
      name: 'registry_type',
      type: 'autocomplete',
      label: 'Registry Type',
      options: RegistryTypes,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'registration_status',
      name: 'registration_status',
      type: 'autocomplete_multiple',
      label: 'Registration Status',
      options: RegistrationStatus,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'start_date',
      name: 'start_date',
      type: 'date',
      label: 'Start Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'end_date',
      name: 'end_date',
      type: 'date',
      label: 'End Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_yacht',
      name: 'id_yacht',
      type: 'async_autocomplete_multiple',
      label: 'Yacht',
      api: yachts.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'provenance',
      name: 'provenance',
      type: 'async_autocomplete_multiple',
      label: 'Provenance',
      api: provenanceList.provenences,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
  ],
  query: {
    keys: [
      {
        key: 'registry_type',
        value: 'registry_type.label',
        operator: '$eq',
      },
      {
        key: 'registration_status',
        value: 'registration_status.label',
        operator: '$eq',
      },
      {
        key: 'date_submit_signature',
        value: 'start_date',
        operator: '$gte',
      },
      {
        key: 'date_submit_signature',
        value: 'end_date',
        operator: '$lte',
      },
      {
        key: 'id',
        value: 'id_yacht.id',
        operator: '$eq',
      },
      {
        key: 'id_attendance.id_provenence_list.provenence.id',
        value: 'provenance.id',
        operator: '$eq',
      },
    ],
  },
};
